// eslint-disable-next-line no-undef
__webpack_public_path__ = (window.HEADER_RENDER_SERVICE && window.HEADER_RENDER_SERVICE.__PUBLIC_PATH__) || '/';
